import React from 'react';
import styled from 'styled-components';

const Wrapper = styled.div`
  background: #2da548;
  display: flex;
  flex-direction: row;
  padding: 16px 0;
  text-align: center;
  justify-content: center;

  font-family: 'Mukta Vaani';
  font-style: normal;
  font-weight: 700;
  font-size: 18px;
  line-height: 24px;
  color: #ffffff;
`;

const CopiedMessage = () => (
  <Wrapper>
    Copied
  </Wrapper>
);

export default CopiedMessage;



// WEBPACK FOOTER //
// ./src/components/onboarding/CopiedMessage.js